import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { getApiVersion, http } from '@vt/apis/lib-ex'
import { cloneDeep } from 'lodash-es'
import Map from '../components/map'
import Modal from '../components/modal'

const Content = function ({ customDsl, data }) {
  const [open, setOpen] = useState(false)

  const [itemData, setItemData] = useState([])
  const { appId } = useParams()

  useEffect(() => {
    let newDsl = cloneDeep(data.dsl)
    const _dsl = cloneDeep(customDsl)
    if (_dsl) {
      if (Object.keys(data.dsl).length !== 0) {
        _dsl.childQueries.push(data.dsl)
      }
      newDsl = _dsl
    }
    Object.assign(newDsl, { size: 5000 })
    http()
      .post(`${getApiVersion()}/apps/${appId}/${data.fetch}`, { ...newDsl })
      .json()
      .then((res) => {
        const positions = res.content
          .filter((c) => {
            return c.lnglat && c.lnglat[0]
          })
          .map((c) => {
            return {
              position: c.lnglat,
              id: c.objectId,
              ...c,
            }
          })
        setItemData(positions)
      })
  }, [customDsl])

  return (
    <>
      <Map data={itemData} />
      <Modal
        open={open}
        onClose={() => {
          setOpen(false)
        }}
      >
        <div>详情</div>
      </Modal>
    </>
  )
}

const MapContainer = function ({ data, customDsl }) {
  return <Content customDsl={customDsl} data={data} />
}

export default MapContainer
